// src/hooks/useSettings.js
import { useState, useEffect, useCallback } from 'react';
import { getDigitalTwinSettings } from '../services/settingsService';

export const useSettings = () => {
  const [settings, setSettings] = useState({ statusColors: {} });
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    const fetchedSettings = await getDigitalTwinSettings();
    setSettings(fetchedSettings);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  // Return the settings, a manual refetch function, and the setter
  return { settings, loading, setSettings, refetchSettings: fetchSettings };
};